import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNotification } from '@eye-able/ui';
import type { PolicyResponse } from '@http/queries/useCreatePolicy';
import { toPolicyStatusUpdateBody } from '@http/queries/useUpdatePolicy';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

/** Archive a custom governance policy (`PUT /policies` with status `archived`). */
export function useArchivePolicy() {
  const queryClient = useQueryClient();
  const notification = useNotification();
  const { t } = useInlineTranslation();

  return useMutation({
    mutationFn: (policy: PolicyResponse) =>
      fetchWrapper.put<PolicyResponse>(
        api.policies,
        toPolicyStatusUpdateBody(policy, 'archived'),
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [api.policies] });
      notification.success(t('policyArchivedSuccess'));
    },
  });
}
